// import axios from 'axios';
import axios from '../axios';


const authAPI = {
  login: async (credentials) => {
    const response = await axios.post('/auth/login', credentials);
    return response.data;
  },

  register: async ({ empId, mosadSn, ...userData }) => {
    if (empId && mosadSn) {
      const response = await axios.post(`/auth/register/${empId}/${mosadSn}`, { ...userData });
      return response.data;
    }
    else {
      const response = await axios.post('/auth/register', { ...userData });
      return response.data;
    }
  },

  forgotPassword: async (email) => {
    const response = await axios.post('/auth/forgot-password', { email });
    return response.data;
  },

  resetPassword: async (token, password) => {
    const response = await axios.post('/auth/reset-password', { token, password });
    return response.data;
  },

  getCurrentUser: async () => {
    const response = await axios.get('/auth/me');
    return response.data;
  },

  updateProfile: async (userData) => {
    const response = await axios.put('/auth/profile', userData);
    return response.data;
  },

  changePassword: async (passwordData) => {
    const response = await axios.put('/auth/change-password', passwordData);
    return response.data;
  },

};

export default authAPI; 